/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
  const initCarousel = (element) => {
    const carousel = element.querySelector('.Carousel--product');
    if (carousel) {
      const options = carousel.dataset.flickityConfig ? JSON.parse(carousel.dataset.flickityConfig) : {};
      let flkty = new Flickity(carousel, options)
      flkty.resize()
    }
  }

  const headerSearchResults = document.querySelector('.shopify-section--header .Search__Results');
  const mutationObserver = new MutationObserver((mutationList, observer) => {
    const attributesChanged = mutationList.find(mutation => mutation.type === "attributes");
    if (attributesChanged) {
      initCarousel(attributesChanged.target)
    }
  });

  if (headerSearchResults) {
    mutationObserver.observe(headerSearchResults, { attributes: true, childList: true, subtree: false });
  }
});
